<template>
  <div class="beranda">
    <section class="sapa">
      <div class="sapa-teks">
        <h1 class="judul-sapa">Selamat datang, {{ nama }}</h1>
        <p v-if="perusahaan" class="sapa-perusahaan">{{ perusahaan }}</p>
        <p class="sapa-isi">
          Buka <strong>Menu</strong> di kanan atas untuk semua fitur, atau langsung ke halaman yang sering dipakai di
          bawah ini.
        </p>
      </div>
      <img class="sapa-kodok" src="/brand/kodok.svg" alt="" width="220" height="168" />
    </section>

    <div class="beranda-kolom">
      <section v-if="pintasan.length" class="blok">
        <h2 class="judul-blok">Sering dibuka</h2>
        <ul class="pintasan">
          <li v-for="p in pintasan" :key="p.path">
            <router-link :to="p.path">
              <span>{{ p.text }}</span>
              <span class="grup">{{ p.grup }}</span>
            </router-link>
          </li>
        </ul>
      </section>

      <section class="blok">
        <h2 class="judul-blok">Langganan dan bantuan</h2>
        <dl class="info">
          <template v-if="langganan">
            <dt>Masa langganan</dt>
            <dd>
              sampai <strong>{{ tanggal }}</strong>
              <span v-if="!langganan.habis" class="info-sisa"> ({{ sisa }})</span>
            </dd>
          </template>
          <dt>Dukungan</dt>
          <dd>
            Portal tiket <a href="https://support.accutrax.id" target="_blank" rel="noopener">support.accutrax.id</a>
          </dd>
          <dt>Panduan</dt>
          <dd><a href="" @click.prevent="panduan">Panduan Pengguna</a> (tab baru)</dd>
        </dl>
        <p class="terima-kasih">
          Terima kasih atas kepercayaan Anda memilih AccuTrax sebagai sistem akuntansi perusahaan Anda. Kami akan
          berusaha semaksimal mungkin memberikan pelayanan yang terbaik.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import { useAppStore } from "@/stores/app-store";
import navigation from "@/app-navigation";
import { tanggalPanjang, kalimatSisa } from "@/helper/langganan";

// Halaman yang paling sering dibuka admin toko; hanya yang boleh dibuka pengguna ini yang tampil.
const SERING = ["jual", "beli", "barang", "pelanggan", "supplier", "kartu_stok", "jurnal", "neraca"];

export default {
  computed: {
    store() {
      return useAppStore();
    },
    nama() {
      const n = this.store.user?.nama || "";
      return n ? n.charAt(0).toUpperCase() + n.slice(1) : "";
    },
    perusahaan() {
      return this.store.setting?.perusahaan?.nama || "";
    },
    langganan() {
      return this.store.langganan;
    },
    tanggal() {
      return tanggalPanjang(this.langganan.berakhir);
    },
    sisa() {
      return kalimatSisa(this.langganan.sisa_hari);
    },
    pintasan() {
      const semua = [];
      for (const grup of navigation) {
        for (const item of grup.items || []) {
          semua.push({ ...item, grup: grup.text });
        }
      }
      return SERING.map((k) => semua.find((i) => i.key === k))
        .filter((i) => i && i.path && this.store.menuTampil(i));
    },
  },
  methods: {
    panduan() {
      window.open(this.$router.resolve({ name: "panduan" }).href, "_blank", "noopener");
    },
  },
};
</script>

<style scoped>
.beranda {
  max-width: 1080px;
  margin: 8px auto 24px;
}
.sapa {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 24px 28px 0;
  border-radius: 16px;
  background: color-mix(in srgb, var(--brand-paper) 80%, var(--surface));
  border: 1px solid var(--line);
  overflow: hidden;
}
.dx-swatch-dark .sapa {
  background: color-mix(in srgb, var(--brand-ink) 26%, var(--surface));
}
.sapa-teks {
  padding-bottom: 24px;
}
.beranda .sapa .judul-sapa {
  margin: 0;
  font-weight: 700;
  font-size: 28px;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--text);
}
.sapa-perusahaan {
  margin: 4px 0 0;
  font-weight: 600;
  color: var(--brand-ink);
}
.dx-swatch-dark .sapa-perusahaan {
  color: var(--brand-leaf);
}
.sapa-isi {
  margin: 12px 0 0;
  max-width: 52ch;
  line-height: 1.55;
  color: var(--text-muted);
}
.sapa-kodok {
  width: 200px;
  height: auto;
  flex: none;
  margin-bottom: -6px;
}
.beranda-kolom {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 16px;
  margin-top: 16px;
}
.blok {
  padding: 20px 24px;
  border-radius: 14px;
  background: var(--surface);
  border: 1px solid var(--line);
}
.beranda .blok .judul-blok {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 700;
  color: var(--text);
}
.pintasan {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 12px;
}
.pintasan a {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 10px;
  color: var(--text);
  font-weight: 600;
  text-decoration: none;
  transition: background-color 140ms ease;
}
.pintasan .grup {
  font-weight: 400;
  font-size: 12px;
  color: var(--text-muted);
}
@media (hover: hover) and (pointer: fine) {
  .pintasan a:hover {
    background: color-mix(in srgb, var(--brand-sun) 18%, var(--surface));
  }
}
.info {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 8px 16px;
  margin: 0 0 16px;
}
.info dt {
  color: var(--text-muted);
}
.info dd {
  margin: 0;
}
.info a {
  color: var(--brand-ink);
  font-weight: 600;
}
.dx-swatch-dark .info a {
  color: var(--brand-leaf);
}
.info-sisa {
  color: var(--text-muted);
}
.terima-kasih {
  margin: 0;
  padding-top: 14px;
  border-top: 1px solid var(--line);
  color: var(--text-muted);
  line-height: 1.55;
  font-size: 14px;
}
@media (max-width: 820px) {
  .beranda-kolom {
    grid-template-columns: 1fr;
  }
  .sapa {
    padding: 20px 20px 0;
  }
  .sapa-kodok {
    width: 130px;
  }
}
@media (max-width: 480px) {
  .pintasan {
    grid-template-columns: 1fr;
  }
  .sapa-kodok {
    display: none;
  }
  .sapa-teks {
    padding-bottom: 20px;
  }
}
</style>
